import {getFilePath} from '@/utils'
export const getImgUrl = {
    methods: {
        getFilePath(fileUrl){
            if(fileUrl == null || fileUrl == undefined) {
                return require("@/assets/defaultPic.jpg")
            }
            return fileUrl.length > 0 ? getFilePath(fileUrl) : require("@/assets/defaultPic.jpg")
        }
    }
};
